import sha1 from "sha1"
import { requestGapi } from "gpages/utils/gapi"
import { postAppMsg } from "gpages/utils/native_bridge"
import { pageUrl, appInfo } from "@config"

const shareImg = "share-logo.png"
const wechatMpAppId = "wxb7bd9d01e180c6ef"

let ticket = null
const defaultShareTitle = appInfo.shareTitle
const defaultShareDescription = appInfo.shareDescription

const weixin =
  typeof window !== "undefined" && window.wx ? window.wx : { config: () => {} }

const getSignature = (timestamp, nonceStr, ticket) => {
  const [url] = window.location.href.split("#")
  const signature = `jsapi_ticket=${ticket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
  return sha1(signature)
}

const getTicket = (callback) => {
  if (ticket) {
    if (callback) {
      callback(ticket)
    }
    return
  }

  requestGapi("wechat-tickets/apply", { method: "POST" }).then((res) => {
    const t = res?.ticket
    if (callback) {
      ticket = t
      callback(t)
    }
  })
}

const wxConfig = () => {
  const timestamp = `${(Number(new Date()) / 1000).toFixed(0)}`
  const nonceStr = Math.random().toString(36).substr(2)

  getTicket((ticket) => {
    weixin.config({
      debug: process.env.NODE_ENV === "development", // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: wechatMpAppId, // 必填，公众号的唯一标识
      timestamp, // 必填，生成签名的时间戳
      nonceStr, // 必填，生成签名的随机串
      signature: getSignature(timestamp, nonceStr, ticket), // 必填，签名，见附录1
      jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
  })
}

const wxShare = (options = {}) => {
  const {
    title = defaultShareTitle,
    desc = defaultShareDescription,
    link = pageUrl,
    imgUrl = `${pageUrl}${shareImg}`,
  } = options
  const data = {
    title,
    link,
    imgUrl,
  }
  const dataWithDesc = {
    ...data,
    desc,
  }
  weixin.ready(() => {
    weixin.updateTimelineShareData(data)
    weixin.updateAppMessageShareData(dataWithDesc)
  })

  const appShareData = {
    ...dataWithDesc,
    image: dataWithDesc.imgUrl,
  }
  postAppMsg("update-share-data", appShareData)
  if (typeof window !== "undefined") {
    window.getShareData = () => {
      return appShareData
    }
  }
}

export { wxConfig, wxShare }
export default weixin
